import { theme } from '@blueprint/ui';

const HideUniversalHeaderStyle = `[data-testid="universal-header"] { display: none; }`;

export const HideUniversalHeader = (
    <style
        data-testid="hide-universal-header"
        dangerouslySetInnerHTML={{
            __html: HideUniversalHeaderStyle
        }}
    />
);

export const HideUniversalHeaderAtMobile = (
    <style
        data-testid="hide-universal-header-mobile"
        dangerouslySetInnerHTML={{
            __html: `@media (max-width: ${theme.breakpoints[1]}px) {${HideUniversalHeaderStyle}}`
        }}
    />
);
